import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.text = this.el.querySelector('.m-text-reveal_text');
        this.eventName = this.el.dataset.textRevealEvent;
        this.timeline = null;
        this.lastProgress = 0;
        this.handleProgress = this.handleProgress.bind(this);
    }

    init() {
        if (!this.text) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.text.classList.add('-no-animation');
            return;
        }

        window.addEventListener(this.eventName, this.handleProgress);

        // textAnimations() découpe d'abord le contenu avec SplitType.
        this.setupTimeout = window.setTimeout(() => this.setupAnimation(), 0);
    }

    setupAnimation() {
        const characters = this.text.querySelectorAll('.char');

        if (characters.length === 0) {
            return;
        }

        this.timeline = gsap.timeline({ paused: true });
        this.timeline.fromTo(
            characters,
            { opacity: 0.1 },
            {
                opacity: 1,
                duration: 0.5,
                ease: 'none',
                stagger: 0.03,
            },
        );
        this.timeline.progress(this.lastProgress);
    }

    handleProgress(event) {
        const progress = Number(event.detail?.progress ?? 0);
        this.lastProgress = Math.min(1, Math.max(0, progress));

        if (this.timeline) {
            this.timeline.progress(this.lastProgress);
        }
    }

    destroy() {
        window.clearTimeout(this.setupTimeout);
        window.removeEventListener(this.eventName, this.handleProgress);
        this.timeline?.kill();
    }
}
